<template>
  <div class="main-layout__list main-layout__list_mxh80">
    <administrators-list-head />

    <administrators-list-item
      v-for="(item, index) in administrators"
      :key="index"
      :item="item"
      :index="index + 1"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import administratorsListItem from '@/components/lists/administrators/administratorsListItem'
import administratorsListHead from '@/components/lists/administrators/administratorsListHead'

export default {
    components: {
        administratorsListItem,
        administratorsListHead,
    },
    computed: {
        ...mapGetters({
            administrators: 'administrators/administratorsGetters',
        }),
    },
    methods: {
        ...mapActions({
            fetch: 'administrators/fetch',
        }),
    },
    async created() {
        await this.fetch()
    },
}
</script>
